module.exports = __webpack_public_path__ + "static/media/anc1ru.4bac11d1.pdf";